import { Quests } from '../State/Player/QuestType';
import DateHelper from '../Utility/DateHelper';

export const questUnlockLevel: number = 9;
export const questTimerDuration: number = DateHelper.Hour * 4;
export const questSlotsCount: number = 3;

export const attemptsToLoadBgTile: number = 3;
export const startingQuests = [
    { type: Quests.CLEAR_CARD_ANY, tier: 1 },
    { type: Quests.CLEAR_CARD_ACES, tier: 2 },
    { type: Quests.COLLECT_STARS, tier: 3 },
];
export const questProgressPopUpDelayFull: number = 850;
export const questProgressPopUpDelay: number = 0;
